import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Spinner } from '@telus-uds/components-web';

import {
  ApproveButton,
  DeclineButton,
  ButtonWrapper,
  PendingApprovalLabel
} from '../css';
import request from '../../utils/request';

const PendingApproval = ({ userId, fetchUsers }) => {
  const [loading, setLoading] = useState(false);

  const handleAction = async action => {
    setLoading(true);
    try {
      const result = await request.post(`/users/${userId}/${action}`);
      if (result) fetchUsers();
    } catch (err) {
      throw err;
    }
  };

  return (
    <Spinner label="Updating..." show={loading}>
      <PendingApprovalLabel>
        Users profile is pending approval. Approve?
      </PendingApprovalLabel>
      <ButtonWrapper>
        <ApproveButton onClick={() => handleAction('approve')}>
          Approve
        </ApproveButton>
        <DeclineButton onClick={() => handleAction('delete')}>
          Decline
        </DeclineButton>
      </ButtonWrapper>
    </Spinner>
  );
};

PendingApproval.propTypes = {
  userId: PropTypes.number.isRequired,
  fetchUsers: PropTypes.func.isRequired
};

export default PendingApproval;
